import { useState, useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $recipientListStore } from '@lib/store';
import { useListState, useRouteHook } from '@shared/hooks';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { SortType } from '@shared/api/models';
import { RecipientsTable } from './recipientsTable';
import { Button, Icon, SearchInput, Text } from '@shared/widgets';
import PlusIcon from '@assets/icons/plus.svg';

interface IListProps {
  className?: string;
}

export const List = (props: IListProps) => {
  const { navigate } = useRouteHook();

  const recipientListStore = useUnit($recipientListStore.store);

  const [search, setSearch] = useState<string>('');
  const recipientsState = useListState({ list: 'recipients', count: 5 });

  const { t } = useTranslation('payments');

  useEffect(() => {
    $recipientListStore.events.update({
      Count: recipientsState.count,
      FromIndex: recipientsState.fromIndex,
      SearchQuery: search,
      ReturnTotalCount: true,
      SortType: SortType.Asc,
    });
  }, [search, recipientsState]);

  return (
    <div
      className={cn(
        'flex flex-col gap-6',
        PaletteUtils.isVcfcPalette && 'rounded-xl bg-white p-6 dark:rounded-xl dark:border dark:border-gray-black dark:bg-soft-black',
        props.className,
      )}
    >
      <div>
        {PaletteUtils.isInsigniaPalette && (
          <Text weight='semibold' size='2xl'>
            {t('recipients.title')}
          </Text>
        )}
        <div
          className={cn(
            'flex items-center',
            PaletteUtils.isInsigniaPalette && 'justify-end',
            PaletteUtils.isVcfcPalette && 'flex-wrap justify-between',
          )}
        >
          {PaletteUtils.isVcfcPalette && (
            <Text className='max-md:mb-6' weight='semibold' size='lg'>
              {t('recipients.title')}
            </Text>
          )}
          <div className={cn('flex gap-3', PaletteUtils.isVcfcPalette && 'flex-wrap items-center')}>
            <SearchInput className='flex-basis-0 flex-shrink-0 flex-grow' value={search} onChange={setSearch} />
            <Button color='outlined' to={RoutePaths.paymentNewRecipients.onNavigate()}>
              <Icon icon={<PlusIcon />} color='inherit' />
              {t('recipients.buttons.addNewRecipient')}
            </Button>
          </div>
        </div>
      </div>
      <RecipientsTable
        isLoading={recipientListStore?.loading}
        data={recipientListStore.data.data}
        totalItemCount={recipientListStore.data.total}
        currentPage={recipientsState.page}
        countItemPage={recipientsState.count}
        onChangePage={recipientsState.onChangePage}
        onChangeCountItemPage={recipientsState.onChangeCount}
        setSelectedItemId={(id) => navigate(RoutePaths.paymentsRecipient.onNavigate(id))}
      />
    </div>
  );
};
